import "./single-blog.scss";
import "sticky-kit/dist/sticky-kit";
import "../../../js/core";
import Collapse from "bootstrap/js/src/collapse";
import { stickySidebar } from "../../../js/sticky-sidebar";
import "../../../js/tooltip-anchor";
import "../../../../assets/src/eos/js/scroll-to-anchor";
import "../../../../assets/src/eos/js/video-youtube-iframe";

import "../../../components/site-elements/other-blocks/faq/faq";

import "../../../components/site-elements/table/table-vh/table-vh";
import { SwiperInit } from "../../../components/site-elements/other-blocks/swiper-tabs/swiper-tabs";
import { rateArticle } from "../../../components/site-elements/other-blocks/rate-article/rate-article";

SwiperInit("swiper-1");
SwiperInit("swiper-2");
rateArticle();

// Slider carousel
$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      jQuery(".single-carousel").owlCarousel({
        responsive: {
          0: {
            items: 1,
            dots: false,
          },
          768: {
            items: 1,
            dots: true,
          },
        },
        nav: true,
        dotsEach: true,
        slideBy: 1,
        margin: 20,
        smartSpeed: 200,
      });
      $(".owl-carousel").each(function (index) {
        $(this)
          .find(".owl-nav, .owl-dots")
          .wrapAll("<div class='owl-controls'></div>");
      });
    });
  });

  let modal = document.querySelector(".download-detailed-info-with-choose");
  let form = modal.querySelector(".download-detailed-info-with-choose form");
  let messageChecked = modal.getAttribute("data-message-checked");

  if (form) {
    form.addEventListener("wpcf7mailsent", function () {
      let checkboxStatus = form.querySelector(
        '.checkbox-wrap input[type="checkbox"]'
      ).checked;
      let userEmail = form.querySelector('input[name="user-email"]').value;
      messageChecked = messageChecked.replace("XXX", userEmail);

      if (checkboxStatus) {
        $.ajax({
          url: `${location.protocol}//${location.hostname}${
            location.port ? ":" + location.port : ""
          }/wp-admin/admin-ajax.php`,
          type: "POST",
          data: {
            action: "logic_for_download_detailed_info_with_choose",
            user_email: userEmail,
          },
        });
        setTimeout(function () {
          document.querySelector("#modalResponseSent .message").innerHTML =
            messageChecked;
        }, 100);
      }
    });
  }
});

// Expanded
$(function () {
  function ExpandListItem() {
    $(".list-item").each(function (index) {
      var $textBlock = $(this).find(".list-content > .inner").height();
      var $contentBlock = $(this).find(".list-content").height();

      if ($textBlock > $contentBlock) {
        $(this).addClass("show-btn");
      } else {
        $(this).removeClass("show-btn");
      }
    });
  }

  ExpandListItem();
  $(window).on("resize", function () {
    ExpandListItem();
  });
  $(".list-item")
    .find(".btn-list")
    .on("click", function (e) {
      e.preventDefault();
      $(this).parent(".list-item.show-btn").toggleClass("expanded");
    });
});

// Popup link
$(function () {
  $("a.show").on("click", function (e) {
    var url = window.location.href;
    var tempInput = document.createElement("input");

    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = url;
    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    $(this).next().fadeIn(500).fadeOut(3000);
  });
});

// Stiky function
stickySidebar(134);

$(document).ready(function () {
  // Collapse close
  $(".accordion-button.less").on("click", function () {
    let closeTargetCollapse = $(this).data("bs-target");
    $(closeTargetCollapse).collapse("hide");
  });
  // Native video player
  $(".wrapper-video").each(function (index) {
    let $video = $(this).find("video");
    let $videoButton = $(this).find(".video-button-wrap");

    $videoButton.on("click", function () {
      $video[0].play();
    });

    $video.attr("controls", false);

    $video.on("play", function () {
      $video.attr("controls", true);
      $videoButton.hide();
      $("#video-start").on("click", function () {});
    });

    $video.on("pause", function () {
      $video.attr("controls", false);
      $videoButton.show();
    });
  });

  let modal = document.querySelector(".download-white-paper-with-choose");

  if (modal) {
    let form = modal.querySelector(".download-white-paper-with-choose form");
    let messageChecked = modal.getAttribute("data-message-checked");

    form.addEventListener("wpcf7mailsent", function () {
      let checkboxStatus = form.querySelector(
        '.checkbox-wrap input[type="checkbox"]'
      ).checked;
      let userEmail = form.querySelector('input[name="user-email"]').value;
      messageChecked = messageChecked.replace("XXX", userEmail);

      if (checkboxStatus) {
        $.ajax({
          url: `${location.protocol}//${location.hostname}${
            location.port ? ":" + location.port : ""
          }/wp-admin/admin-ajax.php`,
          type: "POST",
          data: {
            action: "logic_for_download_white_paper_with_choose",
            user_email: userEmail,
          },
        });
        setTimeout(function () {
          document.querySelector("#modalResponseSent .message").innerHTML =
            messageChecked;
        }, 100);
      }
    });
  }
});

// social links script
$(".social_link").click(function (event) {
  event.preventDefault();

  let url = $(this).attr("href");
  if (url != "#") {
    let width = 600;
    let height = 500;
    let left = (screen.width - width) / 2;
    let top = (screen.height - height) / 2;

    window.open(
      url,
      "",
      "width=" + width + ",height=" + height + ",left=" + left + ",top=" + top
    );
  }
});
